import React, { Component } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import Cards from "../../assets/components/Cards/Cards";
import "./ListeServeurs.css";

class Liste extends Component {
  constructor(props) {
    super(props);
    this.state = { serveur: { tabServeur: [] }, isBenef: true };
  }

  componentDidMount() {
    this.getDataServeurs();
  }

  getDataServeurs = (e) => {
    const headers = new Headers({
      "Content-Type": "application/json",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/client/getDataServeur" +
        window.location.search,
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          this.setState({ serveur: data });
          // Le restaurant est identifié par ?id=<publicId> (propagé via
          // window.location.search). data peut être une erreur 404 (publicId
          // inconnu) -> pas de tabServeur.
          if (!data || !data.tabServeur || data.tabServeur.length === 0) {
            this.setState({ isBenef: false });
          } else {
            localStorage.setItem("restaurantName", data.restaurantName);
            localStorage.setItem("@idRestaurant", data._id);
            localStorage.setItem(
              "serveurReferent",
              data.referent ? data.referent.email : ""
            );
          }
        },

        (error) => {
        }
      );
  };

  display = () => {
    if (this.state.serveur.pourboireIndividuel === true) {
      return this.state.serveur?.tabServeur
        .filter((filter) => filter.serveurPoste != "Manager (Pas de bourboire)")
        .map((element, index) => {
          return (
            <Container fluid>
              <Row className="rowImage">
                <Col>
                  <Image
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      element.serveurPicture
                    }
                  />
                </Col>
              </Row>

              <Row className="rowTitre2">
                <Col s={12}>
                  <p>{element.serveurName}</p>
                </Col>
              </Row>
              <Row className="butTips">
                <Col>
                  <Button
                    onClick={() => {
                      localStorage.setItem("@mailServeur", element.serveurMail);
                      this.props.history.push(
                        "/information-client" + window.location.search
                      );
                    }}>
                    Donner un Pourboire
                  </Button>
                </Col>
              </Row>
            </Container>
          );
        });
    } else {
      return;
    }
  };

  displayGeneral = () => {
    if (
      this.state.serveur?.pourboireGeneral === true &&
      this.state.serveur?.pourboireIndividuel === false
    ) {
      return (
        <Container className="tipsTrueFalse">
          <Row>
            <Col className="colButton">
              <Button
                className="hover"
                onClick={() => {
                  this.props.history.push(
                    "/TipCommun" + window.location.search
                  );
                }}>
                Donner à toute l'équipe !
              </Button>
            </Col>
          </Row>
          {this.state.serveur?.tabServeur
            .filter(
              (filter) => filter.serveurPoste != "Manager (Pas de bourboire)"
            )
            .map((element, index) => {
              return (
                <Container fluid>
                  <Row className="rowImage">
                    <Col>
                      <Image
                        src={
                          process.env.REACT_APP_BACKEND_URL +
                          element.serveurPicture
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="rowTitre2">
                    <Col s={12}>
                      <p>{element.serveurName}</p>
                    </Col>
                  </Row>
                </Container>
              );
            })}
        </Container>
      );
    } else if (
      this.state.serveur?.pourboireGeneral === true &&
      this.state.serveur?.pourboireIndividuel === true
    ) {
      return (
        <Container>
          <Row>
            {" "}
            <Col className="colButton">
              <Button
                onClick={() => {
                  {
                    /*localStorage.setItem(
                    "@mailServeurReferent",
                    element.serveurMail
                  );*/
                  }
                  this.props.history.push(
                    "/TipCommun" + window.location.search
                  );
                }}>
                Donner à toute l'équipe !
              </Button>
            </Col>
          </Row>
          {this.state.serveur?.tabServeur
            .filter(
              (filter) => filter.serveurPoste != "Manager (Pas de bourboire)"
            )
            .map((element, index) => {
              return (
                <Container fluid>
                  <Row className="rowImage">
                    <Col>
                      <Image
                        src={
                          process.env.REACT_APP_BACKEND_URL +
                          element.serveurPicture
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="rowTitre2">
                    <Col s={12}>
                      <p>{element.serveurName}</p>
                    </Col>
                  </Row>
                  <Row className="butTips">
                    <Col>
                      <Button
                        onClick={() => {
                          localStorage.setItem(
                            "@mailServeur",
                            element.serveurMail
                          );
                          this.props.history.push(
                            "/information-client" + window.location.search
                          );
                        }}>
                        Donner un Pourboire
                      </Button>
                    </Col>
                  </Row>
                </Container>
              );
            })}
        </Container>
      );
    } else {
      return this.state.serveur?.tabServeur
        .filter((filter) => filter.serveurPoste != "Manager (Pas de bourboire)")
        .map((element, index) => {
          return (
            <Container fluid>
              <Row className="rowImage">
                <Col>
                  <Image
                    src={
                      process.env.REACT_APP_BACKEND_URL +
                      element.serveurPicture
                    }
                  />
                </Col>
              </Row>

              <Row className="rowTitre2">
                <Col s={12}>
                  <p>{element.serveurName}</p>
                </Col>
              </Row>
              <Row className="butTips">
                <Col>
                  <Button
                    onClick={() => {
                      localStorage.setItem("@mailServeur", element.serveurMail);
                      this.props.history.push(
                        "/information-client" + window.location.search
                      );
                    }}>
                    Donner un Pourboire
                  </Button>
                </Col>
              </Row>
            </Container>
          );
        });
    }
  };
  render() {
    if (this.state.isBenef === false) {
      return (
        <Row className="vousEtes">
          <Col className="colLieu" s={12}>
            <p> Il n'y a pas encore de bénéficiaire dans cet établissement</p>
          </Col>
        </Row>
      );
    } else {
      return (
        <Container className="blocPrincipalClient">
          <Row className="vousEtes">
            <Col className="colLieu" s={12}>
              <Image
                className="logoPicture"
                alt="Logo de l'établissement"
                src={
                  process.env.REACT_APP_BACKEND_URL +
                  (this.state.serveur?.logo || "/images/logo-init.png")
                }
                onError={(e) => {
                  // Logo manquant ou introuvable -> on retombe sur le logo par
                  // défaut au lieu d'une image cassée (TPB-61).
                  e.target.onerror = null;
                  e.target.src =
                    process.env.REACT_APP_BACKEND_URL +
                    "/images/logo-init.png";
                }}
              />
              <h1 className="Titre">
                Lieu : {this.state.serveur?.restaurantName}
              </h1>
              <Image />
            </Col>
          </Row>
          <Row>
            <Col>{this.displayGeneral()}</Col>
          </Row>
        </Container>
      );
    }
  }
}

export default Liste;
